import $ from 'jquery';

$.onAuth(({ website }) => {
  const W = window;
  const $W = $(W);
  const $D = $(document);
  const $clock = $('.app-clock');

  $.subscribe({ type: 'successive', name: 'time' }, (channel, now) => {
    window.now = now;

    const time = $.DateFns.toZonedTime(now * 1000, website.time_zone.code);
    $clock.removeClass('d-none').find('.time').text($.DateFns.format(time, 'eee, h:mm:ss a'));
  });

  $W.on('websocket:closed', () => {
    $('.item-countdown').removeClass('text-warning invisible').addClass('text-strong text-danger').find('span').text('RECONNECTING');
  });

  $D.on('messages', (evt, channel, data = {}) => {
    const now = window.now;
    let [type, id] = channel.split(':');

    if (type === 'time') {
      $('.item-countdown').each((idx, obj) => {
        const $obj = $(obj).removeClass('text-strong text-warning text-danger invisible');
        const dt = Math.max(0, Math.floor($obj.data('end') - data));

        if (dt === 0) $obj.addClass('text-strong text-danger').find('span').text('UPDATING');
        else {
          const v = [];
          let s = dt;
          let d = 0;
          let h = 0;
          let m = 0;

          if (s > 0) {
            d = Math.floor(s / 86400);
            s -= d * 86400;
            if (d >= 1) v.push(`${d} day${d === 1 ? '' : 's'}`);

            h = Math.floor(s / 3600);
            s -= h * 3600;
            if (h >= 1) v.push(`${h} hour${h === 1 ? '' : 's'}`);

            m = Math.floor(s / 60);
            s -= m * 60;
            if (m >= 1 && d < 1) v.push(`${m} minute${m === 1 ? '' : 's'}`);
          }

          if (h < 1 && d < 1) v.push(`${s} second${s === 1 ? '' : 's'}`);

          if (dt < 3600) $obj.addClass('text-strong');
          if (dt < 60) $obj.addClass(dt <= 10 ? ' text-danger' : ' text-warning');

          $obj.find('span').text(v.join(' '));
        }
      });

      return;
    }
  });
});
